import { render, staticRenderFns } from "./MothersDay_cocktailItem.vue?vue&type=template&id=9ff97d16&scoped=true"
import script from "./MothersDay_cocktailItem.vue?vue&type=script&lang=ts"
export * from "./MothersDay_cocktailItem.vue?vue&type=script&lang=ts"
import style0 from "./MothersDay_cocktailItem.vue?vue&type=style&index=0&id=9ff97d16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff97d16",
  null
  
)

export default component.exports